import styled from "styled-components";

const SettingsSectionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin: 16px 0;
    max-width: 800px;
`;

export { SettingsSectionWrapper };
